import i18n from "i18next";

import * as locales from "./language-resources";

const i18next = i18n.createInstance();
void i18next.init({
    resources: locales,
    fallbackLng: "en",
    detection: {
        caches: [],
    },
    ns: ["common"],
    defaultNS: "common",
    interpolation: {
        escapeValue: false,
        formatSeparator: ",",
    },
});

export { i18next };
